module.exports = __webpack_public_path__ + "img/6.75e5d042.jpg";